import BaseDialog from "@/components/BaseDialog";

// 处理队列
export function workOrderQueueModal({ on, props }) {
  return new BaseDialog({
    component: ()=>import('./workOrderQueueModal'),
    options: {
      width: '1060px',
      title: '处理队列',
      top: "60px"
    },
    on,
    props
  })
}

// 标签维护/账户维护弹窗
export function undistributedTipModal({ cbs, props }) {
    return new BaseDialog({
        component: ()=>import('./undistributedTipModal'),
        options: {
            width: '900px',
            title: '温馨提示',
            top: "60px",
            showClose:false,
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass||'',
        },
        cbs,
        props
    })
}

// 个性化配置弹窗
export function pageConfigModal({ cbs, props }) {
  return new BaseDialog({
      component: ()=>import('./pageConfigModal'),
      options: {
          width: '750px',
          title: '个性化配置',
          top: "60px",
          closeOnPressEscape:false,
          closeOnClickModal:false,
          customClass:props.customClass||'',
      },
      cbs,
      props
  })
}
